import { useMemo } from "react";
import { useWorkspaceData } from "#app/lib/data/workspace-data-provider";
import { useFeatureFlags, FeatureFlagKey } from "#app/hooks/use-feature-flags";

/**
 * Every workspace custom-field definition, flag-gated types dropped (photos
 * when the PHOTOS flag is off) — the pool the issues table builds its
 * custom-field columns from and the issue view's add-field flows filter.
 * Reads the workspace data provider; never re-queries.
 */
export function useWorkspaceCustomFields() {
  const { customFields } = useWorkspaceData();
  const { hasFlag } = useFeatureFlags();
  const photosEnabled = hasFlag(FeatureFlagKey.PHOTOS);

  return useMemo(
    () => customFields.filter((field) => photosEnabled || field.type !== "photos"),
    [customFields, photosEnabled],
  );
}
